import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useReport } from "@utils/useReports";

const useGenerateReport = (
  projectId: string,
  reportName: string,
  checkedItems: any
) => {
  const navigate = useNavigate();
  const [isGenerating, setIsGenerating] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { generateReportDirect } = useReport();

  const handleGenerateReport = async (templateId: number) => {
    setIsGenerating(true);
    setError(null);

    try {
      const response = await generateReportDirect(
        projectId,
        reportName,
        templateId,
        checkedItems
      );

      if (response?.task_id) {
        navigate(`/project/${projectId}/report-creation/${response.task_id}`);
      }
    } catch (err) {
      console.error("Error creating report:", err);
      setError("Failed to generate report. Please try again.");
    } finally {
      setIsGenerating(false);
    }
  };

  return { handleGenerateReport, isGenerating, error };
};

export default useGenerateReport;
